export const DEFAULT_TEXTS: Record<string, string> = {
  Title: 'This website uses cookies',
  Body: 'We use necessary cookies to make the website work. With your consent we also use cookies for statistics and marketing. You choose which categories you accept. Some videos and other content from external providers require marketing cookies.',
  TabConsent: 'Consent',
  TabInformation: 'Information',
  TabAbout: 'About',
  BtnNecessaryOnly: 'Necessary cookies only',
  BtnAllowSelected: 'Allow selected cookies',
  BtnAllowAll: 'Allow all cookies',
  SettingsLink: 'Settings',
  CatNecessary: 'Necessary',
  CatStatistics: 'Statistics',
  CatMarketing: 'Marketing',
  CatNecessaryDesc: 'Necessary cookies make the website work, for example so forms remember what you filled in and your cookie choice is saved. The website does not work correctly without them.',
  CatStatisticsDesc: 'Statistics cookies help the organiser understand how the website is used, for example which pages are visited.',
  CatMarketingDesc: 'Marketing cookies are used by external providers to follow visitors across websites and show relevant ads. They are also required to show videos, maps and other embedded content from external providers.',
  AboutText: 'Cookies are small text files stored in your browser. By law we may only store cookies that are necessary without your consent. You can change or withdraw your consent at any time using the cookie icon in the corner of the page.',
  PrivacyLink: 'Privacy policy',
  ConsentId: 'Your consent ID',
  ConsentDate: 'Consent given',
  NoConsentYet: 'You have not made a choice yet.',
  ReadMoreProvider: 'Read more about this provider',
  MaxLifetime: 'Maximum storage time',
  StorageType: 'Type',
  ThirdParty: 'Third party',
  TypeCookie: 'HTTP cookie',
  TypeLocal: 'Local HTML storage',
  TypePixel: 'Pixel',
  Yes: 'Yes',
  No: 'No',
  ThirdPartyNote: 'Cookies that external providers (for example YouTube or Vimeo) store on their own domains cannot be removed by this website. Remove them in your browser settings.',
  BlockedVideo: 'This video requires marketing cookies.',
  BlockedMap: 'This map requires marketing cookies.',
  BlockedContent: 'This content requires marketing cookies.',
  BlockedButton: 'Manage cookies',
  ReopenButton: 'Cookie settings',
  Close: 'Close',
  LifetimeSession: 'Session',
  Lifetime30Minutes: '30 minutes',
  Lifetime3Months: '3 months',
  Lifetime6Months: '6 months',
  Lifetime1Year: '1 year',
  Lifetime13Months: '13 months',
  Lifetime2Years: '2 years',
  LifetimePersistent: 'Persistent',
  LifetimeUnknown: 'Set by the embedded provider',
  LifetimePreview: 'Until the preview expires',
  CookieJirangoConsent: 'Stores your cookie choice for this event.',
  CookieJirangoFormstates: 'Remembers what you filled in on a registration form so it is not lost.',
  CookieJirangoMemberCache: 'Remembers the membership check while you register.',
  CookieJirangoPwd: 'Remembers that you entered the password for a protected page.',
  CookieJirangoPreview: 'Gives access to a preview of an unpublished event.',
  CookieJirangoPush: 'Stores your push notification subscription if you turned notifications on.',
  CookieJirangoCheckout: 'Keeps the card payment session during checkout.',
  CookieGa: 'Distinguishes unique visitors for Google Analytics statistics.',
  CookieGaId: 'Stores session state for Google Analytics.',
  CookieFbp: 'Identifies the browser for Meta advertising and measurement.',
  CookieFr: 'Used by Meta to deliver and measure ads.',
  CookieTr: 'Pixel that reports page visits to Meta.',
  CookieYsc: 'Registers a unique ID for statistics on viewed YouTube videos.',
  CookieVisitorInfo: 'Estimates your bandwidth and stores player settings on YouTube.',
  CookieVisitorPrivacy: 'Stores your cookie choice on YouTube.',
  CookieYtRemote: 'Stores player settings for embedded YouTube videos.',
  CookieVuid: 'Collects video viewing statistics for Vimeo.',
  CookieCfBm: "Used by Vimeo's provider Cloudflare to detect bots.",
  CookieDmV1st: 'Identifies the visitor for Dailymotion statistics and advertising.',
  CookieDmTs: "Stores the visitor's session data on Dailymotion.",
  CookieNid: 'Stores Google preferences and is used by Google Maps.',
  CookieEmbedded: 'Embedded content from other websites can store its own cookies. Which ones depends on the embedded website.',
  ProviderEmbedded: 'Embedded content',
};
